function getField<T>(obj: any, fieldName: string, defaultValue: T): T {
  if (!obj || typeof obj !== 'object') {
    return defaultValue;
  }

  const direct = obj[fieldName];
  if (direct !== undefined && direct !== null) {
    return direct as T;
  }

  const target = fieldName.toLowerCase();
  for (const key of Object.keys(obj)) {
    if (key.toLowerCase() === target) {
      const value = obj[key];
      return value !== undefined && value !== null ? (value as T) : defaultValue;
    }
  }

  return defaultValue;
}

export class StudioCourseModule {
  ModuleId: number;
  Ordinal: number;
  Title: string;
  AssignmentStatus: number;
  ModuleAssignment: CourseModuleAssignment;

  constructor(init?: Partial<StudioCourseModule> | any) {
    this.ModuleId = getField<number>(init, 'ModuleId', 0);
    this.Ordinal = getField<number>(init, 'Ordinal', 0);
    this.Title = getField<string>(init, 'Title', '');
    this.AssignmentStatus = getField<number>(init, 'AssignmentStatus', 0);

    const moduleAssignment = getField<any>(init, 'ModuleAssignment', null);
    this.ModuleAssignment = moduleAssignment
      ? new CourseModuleAssignment(moduleAssignment)
      : new CourseModuleAssignment();
  }
}

export class CourseModuleAssignment {
  ModuleAssignmentId: number;
  UserId: number;
  AssignmentStatus: number;
  Assignments: CourseLessonAssignment[];

  constructor(init?: Partial<CourseModuleAssignment> | any) {
    this.ModuleAssignmentId = getField<number>(init, 'ModuleAssignmentId', 0);
    this.UserId = getField<number>(init, 'UserId', 0);
    this.AssignmentStatus = getField<number>(init, 'AssignmentStatus', 0);

    const assignments = getField<any[]>(init, 'Assignments', []);
    this.Assignments = assignments.map(assignment => new CourseLessonAssignment(assignment));
  }
}

export class CourseLessonAssignment {
  LessonAssignmentId: number;
  LessonId: number;
  AssignmentStatus: number;
  Ordinal: number;
  Title: string;

  constructor(init?: Partial<CourseLessonAssignment> | any) {
    this.LessonAssignmentId = getField<number>(init, 'LessonAssignmentId', 0);
    this.LessonId = getField<number>(init, 'LessonId', 0);
    this.AssignmentStatus = getField<number>(init, 'AssignmentStatus', 0);
    this.Ordinal = getField<number>(init, 'Ordinal', 0);
    this.Title = getField<string>(init, 'Title', '');
  }
}
